<template>

    <div v-show="display" id="preverite-podatke">

        <table class="table table-user-information">
            <tbody>
            <tr>
                <td><b>Vaši podatki:</b></td>
            </tr>
            <tr>
                <td>Ime:</td>
                <td><b>{{model.customer.first_name}}</b></td>
            </tr>
            <tr>
                <td>Priimek</td>
                <td><b>{{model.customer.last_name}}</b></td>
            </tr>
            <tr>
                <td>Email</td>
                <td><b>{{model.customer.email}}</b></td>
            </tr>
            <tr>
                <td>Telefon</td>
                <td><b>{{model.customer.telephone}}</b></td>
            </tr>
            <tr>
                <td>Naslov</td>
                <td><b>{{model.customer.address}}</b></td>
            </tr>
            <tr>
                <td>Poštna številka</td>
                <td><b>{{model.customer.postal_code}}</b></td>
            </tr>
            <tr>
                <td>Mesto</td>
                <td><b>{{model.customer.city}}</b></td>
            </tr>
            <tr>
                <td>Dan rojstva</td>
                <td><b>{{model.customer.birthday_day}}</b></td>
            </tr>
            <tr>
                <td>Mesec rojstva</td>
                <td><b>{{model.customer.birthday_month}}</b></td>
            </tr>
            <tr>
                <td>Leto rojstva</td>
                <td><b>{{model.customer.birthday_year}}</b></td>
            </tr>
            <tr>
                <td>Minuta rojstva</td>
                <td><b>{{model.customer.birthday_minute}}</b></td>
            </tr>
            <tr>
                <td>Ura rojstva</td>
                <td><b>{{model.customer.birthday_hour}}</b></td>
            </tr>
            </tbody>
        </table>

        <table v-if="model.additional_codes"  v-for="data in model.additional_codes_data" class="table table-user-information">
            <tbody>
                <tr>
                    <td><b>Dodatna oseba</b></td>
                </tr>
                <tr>
                    <td>Ime:</td>
                    <td><b>{{data.first_name}}</b></td>
                </tr>
                <tr>
                    <td>Priimek</td>
                    <td><b>{{data.last_name}}</b></td>
                </tr>
                <tr>
                    <td>Dan rojstva</td>
                    <td><b>{{data.birthday_day}}</b></td>
                </tr>
                <tr>
                    <td>Mesec rojstva</td>
                    <td><b>{{data.birthday_month}}</b></td>
                </tr>
                <tr>
                    <td>Leto rojstva</td>
                    <td><b>{{data.birthday_year}}</b></td>
                </tr>
                <tr>
                    <td>Minuta rojstva</td>
                    <td><b>{{data.birthday_minute}}</b></td>
                </tr>
                <tr>
                    <td>Ura rojstva</td>
                    <td><b>{{data.birthday_hour}}</b></td>
                </tr>
            </tbody>
        </table>

    </div>

</template>

<script>


    export default {

        props: ["model", "checkout"],

        data: function () {
            return {
                display: false
            }
        },

        methods: {
            init() {
                    this.display = true;
            }
        }


    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/modules/CustomerDataConfirmation.vue